require('./bootstrap');
window.Vue = require('vue');
Vue.filter('rupiah',function (nominal) {
    return String(nominal).replace(/(.)(?=(\d{3})+$)/g,'$1,')
  })

Vue.component('chartcontainer', require('./components/ChartContainer.vue').default);
Vue.component('goodtable', require('./components/Table.vue').default);
Vue.component('pagination', require('laravel-vue-pagination'));

const app = new Vue({
    el: '#app',
    
    
});


